import { Button, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import { updateMinuteStatus } from "../../../../services/minutes.service";
import { Select } from "../../../Common/Select";
import Toastmessage from "../../../Common/ToastMessage";
import { getMinutesStatusOptions } from "../../utils";
import ModalBase from "../../utils/ModalBase";
import SureCancelMinuteSignaturesModal from "../SureCancelMinuteSignaturesModal";
import { ConcludeButtonContainer, Header } from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    borderRadius: 25,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const UpdateMinuteStatusModal = ({
  currentMinuteStatus,
  setModalStatus,
  minuteId,
  onSuccess,
  isRoundRobinMeet,
  t,
}) => {
  const classes = useStyles();
  const [status, setStatus] = useState();
  const [loading, setLoading] = useState(false);
  const [isSureCancelMinuteModalOpen, setIsSureCancelMinuteModalOpen] = useState(false);

  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });

  const minuteStatusOptions = useMemo(() => {
    const ignoredStatus = [
      ...(!isRoundRobinMeet ? 'C' : ''),
      currentMinuteStatus,
      "EA",
      "NI"
    ];
    
    const minuteOptions = getMinutesStatusOptions(ignoredStatus);

    return minuteOptions;
  }, [isRoundRobinMeet, currentMinuteStatus ]);

  const handleUpdateStatus = async (userSureAboutCancelMinute) => {
    if (!status) {
      setMessage({
        open: true,
        content: t("forms.minutes.updateMinuteStatusModal.selectStatusRequired"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }
    
    if (currentMinuteStatus == "EA" &&
      userSureAboutCancelMinute !== true) {
      setIsSureCancelMinuteModalOpen(true);
      return;
    }

    setLoading(true);

    const updateRes = await updateMinuteStatus(minuteId, status.id);

    setLoading(false);

    if (updateRes.error) {
      setMessage({
        open: true,
        content: t("forms.minutes.updateMinuteStatusModal.updateMinuteStatusError"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    onSuccess();
  };

  return (
    <>
      <div>
      <Toastmessage
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
        close={() =>
          setMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
        <ModalBase
          maxWidth={"md"}
          open={isSureCancelMinuteModalOpen}
          setOpen={setIsSureCancelMinuteModalOpen}
          content={
            <SureCancelMinuteSignaturesModal
              isOpen={setIsSureCancelMinuteModalOpen}
              handleUpdateStatus={handleUpdateStatus} 
              setOpen={setIsSureCancelMinuteModalOpen}
            />
          }
        />
        <Header>
          <div>
            <span
              style={{ float: "right", cursor: "pointer" }}
              onClick={() => {
                setModalStatus(false);
              }}
            >
              [X] Fechar
            </span>

            <span className={classes.titleModal}>
              {t("forms.minutes.updateMinuteStatus")}
            </span>
          </div>
        </Header>

        <Grid container spacing={3}>
          <Grid item lg={12} xs={12}>
            <Select
              value={status}
              setValue={(value) => {
                setStatus(value);
              }}
              id="status"
              error={!status}
              required={true}
              options={minuteStatusOptions}
              label={t("forms.status")}
            />
          </Grid>
        </Grid>

        <ConcludeButtonContainer>
          <Button
            className={classes.buttonOutlined}
            variant="outlined"
            onClick={() => setModalStatus(false)}
          >
            {t("forms.committee.buttons.cancel")}
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            onClick={handleUpdateStatus}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={"1rem"} />
            ) : (
              t("forms.committee.buttons.save")
            )}
          </Button>
        </ConcludeButtonContainer>
      </div>
    </>
  );
};

export default UpdateMinuteStatusModal;
